import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Eyebrow } from "./Reveal";

const Photo = ({ src, alt, cls, testid }) => (
  <div data-testid={testid} className={`rounded-[28px] overflow-hidden bg-white ${cls}`}>
    <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover" />
  </div>
);

export const BeyondBusiness = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section ref={ref} data-testid="beyond-business-section" className="py-20 lg:py-28 bg-[#BDE3FA]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-7 order-2 lg:order-1">
            <Photo testid="rory-students-photo" src="/img/rory-students.jpg" alt="Rory sharing his story with junior high students holding Swole Bears" cls="aspect-[4/3]" />
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5 order-1 lg:order-2">
            <Eyebrow className="text-[#1B1530]/70 mb-4">Chase the crazy dream</Eyebrow>
            <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">If a 14-year-old can do it, so can you.</h2>
            <p className="mt-6 text-base sm:text-lg text-[#1B1530]/80 leading-relaxed">Rory visits schools to share his story with junior high students. His goal is to inspire other kids to chase their dreams and show them that being young isn't a reason to wait.</p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 items-center mt-20">
          <Reveal className="lg:col-span-5">
            <Eyebrow className="text-[#1B1530]/70 mb-4">Off the clock</Eyebrow>
            <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">Founder and athlete.</h2>
            <p className="mt-6 text-base sm:text-lg text-[#1B1530]/80 leading-relaxed">Rory's an athlete too. When he's not making gummies, you'll find him on the baseball diamond.</p>
          </Reveal>
          <motion.div style={{ y }} className="lg:col-span-5 lg:col-start-8">
            <Photo testid="rory-baseball-photo" src="/img/rory-baseball.jpg" alt="Rory playing baseball" cls="aspect-[3/4] max-w-md mx-auto rotate-[2deg]" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
